/**
 * Origins the app talks about, in a form that works on the server as well as in the browser.
 *
 * Two different things, and conflating them is how SSR gets subtly wrong:
 *
 * - **api origin** — where app data is fetched from. Empty in the browser, because every request
 *   is same-origin and relative. On the server it is the sibling `app-api` container, reached
 *   directly over the pod network, so a render never leaves the node.
 * - **public origin** — the scheme and host the *visitor* used, reconstructed from the forwarded
 *   headers. This is what canonical URLs and og:image have to say, and it is never the pod's own
 *   address.
 *
 * Both are set once per render on the server (see `entry-server.tsx`) and never on the client.
 */

let apiOrigin = '';
let publicOriginOverride = '';

export function setApiOrigin(origin: string): void {
    apiOrigin = origin.replace(/\/+$/, '');
}

export function setPublicOrigin(origin: string): void {
    publicOriginOverride = origin.replace(/\/+$/, '');
}

/** Absolute on the server, unchanged (relative) in the browser. */
export function apiUrl(path: string): string {
    return apiOrigin ? `${apiOrigin}${path}` : path;
}

/** The visitor-facing origin, or '' if it is not knowable (client before mount is never that). */
export function publicOrigin(): string {
    if (typeof window !== 'undefined') return window.location.origin;
    return publicOriginOverride;
}
